import { CommunityData, CommunityMember } from '../types/misc';
import Community from '../types/community';
import httpService from './httpService';
import { store } from '../redux/store';
import { setState } from '../redux/slices/applicationSlice';

export function getCommunityMembers(communityId: number, count?: number): Promise<CommunityMember[]> {
  const basePath = `/networks/communities/${communityId}/members/`;
  const path = typeof count === 'number' ? `${basePath}?count=${count}` : basePath;
  return httpService.get<CommunityMember[]>(path).then(({ data }) => data);
}

export function getByBusinessId(businessId: number): Promise<CommunityData | null> {
  return httpService
    .get<CommunityData>(`/networks/businesses/${businessId}`)
    .then(({ data }) => data)
    .catch(() => null);
}

/**
 * Get all communities for the current user
 */
export function getMyCommunities(): Promise<CommunityData[]> {
  return httpService.get<CommunityData[]>('/networks/communities/@me').then(({ data }) => data);
}

/**
 * Get a specific community by ID
 */
export function getCommunityById(communityId: number): Promise<CommunityData> {
  return httpService.get<CommunityData>(`/networks/communities/${communityId}`).then(({ data }) => data);
}

/**
 * Fetch communities and businesses and update Redux state
 */
export async function fetchCommunities(): Promise<void> {
  const { data: communities } = await httpService.get<Community[]>('/networks/communities/@me');
  const { data: businesses } = await httpService.get('/networks/businesses');
  store.dispatch(setState({ ...store.getState().application, communities, businesses }));
}

export default {
  getCommunityMembers,
  getByBusinessId,
  getMyCommunities,
  getCommunityById,
  fetchCommunities,
};
